import { render, staticRenderFns } from "./ElementPeriodFactTableColumn.vue?vue&type=template&id=ef275a68&scoped=true"
import script from "./ElementPeriodFactTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementPeriodFactTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementPeriodFactTableColumn.vue?vue&type=style&index=0&id=ef275a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef275a68",
  null
  
)

export default component.exports